import React from 'react';
import { connect } from 'react-redux';
import properties from '../../modules/ajio-util/properties';
// import './error.scss';

const imageBaseUrl = properties.getProperty('imageBaseUrl');

class Error504 extends React.Component {
  render() {
    const { show = false, className = '', mobile = false, device = '' } = this.props;
    return (
      <div className={`http-error notfound ${className}`}>
        <a href="/">
          <img
            className="not-found__image img-responsive"
            src={
              device == 'mobile'
                ? `${imageBaseUrl}/static/img/404_m.jpg`
                : `${imageBaseUrl}/static/img/404.jpg`
            }
            alt="Page not available image"
          />
        </a>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { httpError = {} } = state;
  const { name } = ownProps;
  let show = false;
  if (httpError[name] && httpError[name].errorCode == 504) {
    show = true;
  }
  return {
    show
  };
};

export default connect(mapStateToProps)(Error504);
